export default __webpack_public_path__ + "static/media/intro.d7faa0d3.png";